<template>
  <div>
    <v-data-table
      v-bind="$attrs"
      v-on="$listeners"
      :page.sync="page"
      ref="DataTable"
      class="elevation-0"
      style="white-space: nowrap"
      hide-default-footer
      :items-per-page="itemsPerPage"
      loading-text="Carregando... Aguarde"
      no-data-text="Não há dados disponíveis"
    >
      <!-- passa slots comuns -->
      <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
        <slot :name="slotName" />
      </template>

      <!-- passa slots com escopo -->
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        v-slot:[scopedSlotName]="slotData"
      >
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
    </v-data-table>
    <template v-if="paginate">
      <div class="text-left pt-0" v-if="$attrs.items">
        <v-pagination
          color="#313a46"
          v-model="page"
          :length="pageCount"
          :total-visible="10"
          @input="$emit('pageChange', page)"
        ></v-pagination>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "newbasetable",

  props: {
    paginate: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    lastPage: {
      type: Number,
      default: null,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      page: this.currentPage,
    };
  },

  computed: {
    pageCount() {
      if (this.lastPage == null) {
        return Math.ceil(this.$attrs.items.length / this.itemsPerPage);
      } else {
        return this.lastPage;
      }
    },
  },
};
</script>
<style scoped>
/deep/.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 60px;
}
</style>
